
import { reactive, computed, onMounted, onUnmounted } from 'vue';
import layoutMain from '@/components/layout/layoutMain/index.vue';
import Header from '@/components/layout/header/index.vue';
import { useRoute, useRouter } from 'vue-router';
import { BTN, FEATURENAME, POPUP, TASKTAB, ENV, LANG } from '@/enum/enum';
import { useStore } from 'vuex';
import { apiLogout, apiMe, apiWsSite, apiNotificationsCount } from '@/api/api';
import { wsInit } from '@/ws';
import * as moment from 'moment';
import { dateTimeHandle } from '@/utils/time';
import { uuid } from 'vue-uuid';
import { useI18n } from 'vue-i18n';
import { CONIFG } from '@/config';
import { useGtm } from 'vue-gtm';
import VueGtmPlugin from 'vue-gtm/dist/plugin';
import { checkEnvFromDomain } from '@/utils/utils';

// import Message from '@/view/message/index.vue';
export default {
  components: {
    layoutMain,
    // Message,
    Header,
  },
  props: {


  },
  setup() {
    const store = useStore();
    const storeState = store.state;
    const route = useRoute();
    const router = useRouter();
    const { locale, t } = useI18n();
    let _env = checkEnvFromDomain();




    const currentPageName = computed(() => route.name);

    let refreshTime = computed(() => store.state.refreshTime);
    console.log('currentPageName', route.params);

    router.beforeResolve(() => {
      // console.log('beforeResolve');
    })


    let interval = null;

    onMounted(() => {
      getUserData();
      const path = route.path;
      const pathLevel = path.split('/').length;
      console.log('pathLevel', pathLevel);
      state.isBack = pathLevel > 3 ? true : false;
      _getCurrentTime();
      _init();
      //本地端一直打太煩了先關掉
      const isLocalAlert = process.env.NODE_ENV == 'dev' || process.env.NODE_ENV == 'mock' ? undefined : process.env.NODE_ENV;
      if (isLocalAlert) {
        interval = setInterval(() => {
          _init(false);
        }, storeState.alertUpdateTime);
      } else {
        interval = null;
      }


    });




    onUnmounted(() => {
      clearInterval(interval);
    })

    const _init = (isNeedLoading = true) => {
      getAPINotificationsNew(isNeedLoading)
    } //end: init


    const getAPINotificationsNew = async (isNeedLoading = true) => { //取得header的訊息總數
      store.commit('setIsNeedLoading', isNeedLoading);
      try {
        const datas = await apiNotificationsCount();
        // console.log('apiNotificationsCount', datas)
        let total = 0;
        if (!datas.status_code) {
          for (let key in datas) {
            if (key != "status_code" && key != "message") {
              total += datas[key]
            }
          }
          store.commit('setAlertNotification', total)
        }
      }
      catch (error) {
        return error;
      }
    }


    const _getCurrentTime = () => {
      state.time = dateTimeHandle(moment(), '', 'YYYY/MM/DD HH:mm:ss');
      store.commit('setRefreshTime', state.time);
    }
    //左側選單內容
    const state = reactive({
      isBack: false,
      breadcrumb: [],
      updateTime: '',
      time: '2021/12/12',
      btnIsShow: false,
    })

    const brand = computed(() => store.state.brand);


    //multi lang
    const sidemenu = computed(() =>
      [
        {
          link: FEATURENAME.DASHBOARDDEFAULT,
          text: t('__d7d_n17r.__dashboard'),
          icon: 'ui-menu-dashboard',
          gtmId: '__dashboard',
        }, {
          link: FEATURENAME.DEVICE,
          text: t('__d7d_n17r.__deviceManagement'),
          icon: 'ui-menu-device',
          gtmId: '__deviceManagement',
        }, {
          link: FEATURENAME.TASK,
          text: t('__t4.__taskManagement'),
          query: { tabId: TASKTAB.EXECUTED },  //有default預設的參數必須帶入
          icon: 'asus_proart_sw_ico_task',
          gtmId: '__taskManagement',
        }, {
          link: FEATURENAME.GROUP,
          text: t('__d7d_n17r.__groupManagement'),
          icon: 'ui-menu-group',
          gtmId: '__groupManagement',
        }, {
          link: FEATURENAME.CLOUD,
          text: t('__d7d_n17r.__cloudTargets'),
          icon: 'ui-menu-cloud',
          gtmId: '__cloudTargets',
        }, {
          link: FEATURENAME.CALIBRATIONDEFAULT,
          text: t('__d7d_n17r.__colorCalibration'),
          icon: 'ui-menu-calibration',
          gtmId: '__colorCalibration',
        },
      ],
    )

    const sideInfo = computed(() =>{
      let infoList = [
        {
          text: t('__main.__language'),
          icon: 'top-language',
          id: 'language',
          sub: [
            {
              name: "English",
              val: LANG.EN,
            },
            {
              name: "Taiwan/繁體中文",
              val: LANG.TW,
            },
            {
              name: "Chinese mainland/简体中文",
              val: LANG.CH
            },
            {
              name: "Japan/日本語",
              val: LANG.JP
            },
            {
              name: "Netherlands/Nederlands",
              val: LANG.DUTCH
            },{
              name: "Frence/Français",
              val: LANG.FRE
    
            },
            {
              name: "Germany/Deutsch",
              val: LANG.GER
              
            },
            {
              name: "Indonesian/Bahasa Indonesia",
              val: LANG.IND
              
            },
            {
              name: "Italy/Italiano",
              val: LANG.ITA
              
            },
            {
              name: "Korea, Republic of/한국어",
              val: LANG.KOR
              
            },
            {
              name: "Poland/Polski",
              val: LANG.POLISH
              
            },
            {
              name: "Romania/România",
              val: LANG.ROMANIAN
              
            },
            {
              name: "Russia/Россия",
              val: LANG.RUSSIAN
              
            },
            {
              name: "Spanish/Español",
              val: LANG.SPAN
              
            },
            {
              name: "Sweden/Svenska",
              val: LANG.SWEDISH
              
            },
            {
              name: "Thailand/ไทย",
              val: LANG.THAI
              
            },
            {
              name: "Turkey/Türkçe",
              val: LANG.TUR
              
            },
            {
              name: "Ukraine/Українська",
              val: LANG.UKR
            },
            {
              name: "Vietnam/Việt Nam",
              val: LANG.VIE
    
            }]
        }, {
          text: 'Information',
          icon: 'top-info_n',
          id: 'information',
          sub: [
            {
              name: t('__main.__userManual', { brand: brand.value }),
              val: '__main.__userManual',
            },
            {
              name: t('__main.__proartCalibrationWindows', { brand: brand.value }),
              val: '__main.__proartCalibrationWindows',
            },
            {
              name: t('__main.__userLicenseAgreement'),
              val: '__main.__userLicenseAgreement',
            },
            {
              name: t('__main.__privacyPolicy'),
              val: '__main.__privacyPolicy',
            },
            // {
            //   name: t('__main.__license'),
            //   val: '__main.__license',
            // },
          ]
        }, {
          text: t('__main.__contactAsus'),
          query: { tabId: TASKTAB.EXECUTED },  //有default預設的參數必須帶入
          icon: 'top-email_n',
          id: 'contactUs',
          sub: []
        }, 
      ]

      if (process.env.NODE_ENV !== ENV.PROD && process.env.NODE_ENV !== ENV.STAGING  && process.env.NODE_ENV !== ENV.DEV) {
        return infoList
      }else{
        // infoList[1].sub.shift()
        // infoList[1].sub.splice(2,1)
        return infoList
        
      }

    })

    //multi lang
    const infoList = computed(() => {
      let arr = [t('__main.__userManual', { brand: brand.value }), t('__main.__userLicenseAgreement'), t('__main.__privacyPolicy'), t('__main.__license')]
      if (process.env.NODE_ENV !== ENV.PROD && process.env.NODE_ENV !== ENV.STAGING  && process.env.NODE_ENV !== ENV.DEV) {
        return arr
      }else{
        arr.shift()
        arr.splice(2,1)
        return arr
      }
      
    });



    //左側選單active index
    const sideMenuActive = computed(() => {
      _getCurrentTime();
      switch (currentPageName.value) {
        case FEATURENAME.DASHBOARD:
        case FEATURENAME.NOTIFICATION:
          return 0;
        case FEATURENAME.DEVICEDETAIL:
        case FEATURENAME.DEVICE:
          return 1;
        case FEATURENAME.TASK:
          return 2;
        case FEATURENAME.GROUPDETAIL:
        case FEATURENAME.GROUP:
          return 3;
        case FEATURENAME.CLOUD:
          return 4;
        case FEATURENAME.CALIBRATION:
          return 5;
        case FEATURENAME.CALIBRATIONDEFAULT:
          return 5;
        case FEATURENAME.ADVANCED:
          return 5;
        case FEATURENAME.MODIFY:
          return 5;
        default:
          return 0;
      }

    })
    //標題麵包屑
    const breadcrumb = computed(() => {
      state.btnIsShow = false;
      switch (currentPageName.value) {
        case FEATURENAME.DASHBOARD:
          state.isBack = false;
          return [{
            text: t('__d7d_n17r.__dashboard'),
            link: 'main/dashboard',
          }]
        case FEATURENAME.DASHBOARDDEFAULT:
          state.isBack = false;
          return [{
            text: t('__d7d_n17r.__dashboard'),
            link: 'main/dashboard',
          }]
        case FEATURENAME.DEVICE:
          state.isBack = false;
          return [{
            text: t('__d7d_n17r.__deviceManagement'),
            link: 'main/device',
          }]
        case FEATURENAME.TASK:
          state.isBack = false;
          return [{
            text: t('__t4.__taskManagement'),
            link: `main/tasks/${TASKTAB.EXECUTED}`,
          }]
        case FEATURENAME.NOTIFICATION:
          state.isBack = true;
          return [{
            text: t('__d7d_n17r.__dashboard'),
            link: 'main/dashboard',
          },
          {
            text: t('__d7d_n17r.__notificationCenter'),
            link: 'main/dashboard/notification',
          }]

        case FEATURENAME.GROUP:
          state.isBack = false;
          return [{
            text: t('__d7d_n17r.__groupManagement'),
            link: 'main/group',
          }]

        case FEATURENAME.GROUPDETAIL:
          state.isBack = true;
          return [{
            text: t('__d7d_n17r.__back'),
            link: 'main/group',
          }]
        case FEATURENAME.DEVICEDETAIL:
          state.isBack = true;
          return [{
            text: t('__d7d_n17r.__back'),
            link: 'main/device',
          }]

        case FEATURENAME.CLOUD:
          state.isBack = false;
          return [{
            text: t('__d7d_n17r.__cloudTargets'),
            link: 'main/cloud',
          }]

        case FEATURENAME.CALIBRATIONDEFAULT:
          state.isBack = false;
          return [{
            text: t('__d7d_n17r.__colorCalibration'),
            link: 'main/calibration',
          }]
        case FEATURENAME.CALIBRATION:
          state.isBack = false;
          return [{
            text: t('__d7d_n17r.__colorCalibration'),
            link: 'main/calibration',
          }]

        case FEATURENAME.ADVANCED:
          state.isBack = true;
          state.time = '';
          return [{
            text: t('__d7d_n17r.__colorCalibration'),
            link: 'main/calibration',
          }, {
            text: t('__a7d.__advancedSettings'),
            link: 'main/calibration/advanced',
          }]
        case FEATURENAME.MODIFY:
          state.isBack = true;
          state.time = '';
          state.btnIsShow = true;
          return [{
            text: t('__d7d_n17r.__colorCalibration'),
            link: 'main/calibration',
          }, {
            text: t('__d7d_n17r.__modifySetting'),
            link: 'main/calibration/modify/' + route.params.name,
          }]
        default:
          state.isBack = false;
          return [{
            text: t('__d7d_n17r.__dashboard'),
            link: 'main/dashboard',
          }]
      }
    })

    // watch(() => currentPageName, (val) => {
    //   switch (val.value) {
    //     case FEATURENAME.DASHBOARD:
    //       state.sideMenuActive = 0;
    //       break;
    //     case FEATURENAME.DEVICE:
    //       state.sideMenuActive = 1;
    //       break;
    //     case FEATURENAME.NOTIFICATION:
    //       state.sideMenuActive = 0;
    //       break;
    //     default:
    //       state.sideMenuActive = 0;
    //       break;
    //   }

    // })

    state.breadcrumb = [{

    }]

    // contact modal

    //  -- contact show modal
    const onClickContact = () => {
      console.log('onClickContact');
      // open another tab url 
      window.open('https://www.asus.com/support/');
      // showPopup(POPUP.CONTACT)
    }

    const onClickNotification = () => {
      router.push(`/${"main/dashboard/notification"}`);

    }

    // -- contact confirm submit
    store.watch((state) => (state.isShowModal, state.modalType), (newType, oldType) => {
      // console.log('oldType', oldType)
      // modal type
      if (oldType === POPUP.CONTACT) {
        console.log('contact modal change');
        // modal btn type
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          console.log('confirm');
        }
      } //end: modal
    })

    const showPopup = (popupName, data = '') => {
      console.log('i need to see it!!!', data)
      const modalConfig = {
        type: popupName,
        data: data,
        isShow: true,
      }
      store.commit('setIsShowModal', modalConfig)
    }

    // -- click add device
    const onClickAddDevice = () => {
      showPopup(POPUP.GLOBALADDDEVICE)
    }


    // -- click license
    const onClickLicense = () => {
      showPopup(POPUP.LICENSE)
    }

    const user = reactive({
      name: '---',
      email: '---',
      id : null,
      isShowPrivacy: true,
      isShowEULA: true,
    })


    //set GTM userinfo
    const loginGTM = async () => {
      let idid = null
      idid = storeState.userInfo.gtmUserId

      console.log("送給 GTM 的 ID", idid)
      window.dataLayer?.push({
        event: 'login',
        userId : idid
      });
      
    } // login

    // get user profile
    const getUserData = async () => {
      try {
        let _data = await apiMe();
        console.log('_data', _data);
        let isPolicyVersionSame = _data.policy_agreement === CONIFG.policy_version;
        console.log('isPolicyVersionSame', isPolicyVersionSame)
        user.name = _data.name;
        user.email = _data.email;
        user.id = _data.id;
        user.isShowPrivacy = !(isPolicyVersionSame) || !(_data.eula);

        console.log('user.isShowPrivacy', user.isShowPrivacy)
        console.log('user.isShowEULA', user.isShowEULA)
        console.log('user', user)

        // check ula and privacy
        if (user.isShowPrivacy) {
          let modalConfig = {
            type: POPUP.PRIVACY + uuid.v4(),
            data: [],
            isShow: true,
          }
          store.commit('setIsShowModal', modalConfig)

        }//
        else {
          if (user.isShowPrivacy) {
            let modalConfig = {
              type: POPUP.AGREEMENT + uuid.v4(),
              data: [],
              isShow: true,
            }
            store.commit('setIsShowModal', modalConfig)
          }
        }//

        //測試專用
        if(process.env.NODE_ENV == ENV.DEV && _data.name == null && _data.email  == null){
          user.email = 'cerise@gmail.com';
          user.name = 'cerise huang gg QQ';
        }
        //測試專用

        const config = {
          email: user.email,
          name: user.name,
          gtmUserId : user.id,
          isShowPrivacy: user.isShowPrivacy,
          isShowEULA: user.isShowEULA,
        };
        store.commit('setUserInfo', config)
        loginGTM()
        await queryApiWsSite()
        wsInit()

      }
      catch (err) {
        console.log('err', err.response);

      }//end: catch
    }

    // privacy notice handler 
    // store.watch((state) => (state.isShowModal, state.modalType), (newType, oldType) => {
    //   // modal type
    //   // console.log('newType, new', newType, 'old', oldType);
    //   // if (oldType === POPUP.DEMO) {
    //   //   console.log('toreState.modalBtnType', storeState.modalBtnType);
    //   //   // modal btn type
    //   //   if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
    //   //     console.log('confirm');
    //   //     const output = storeState.modalOutput
    //   //     state.modalGetData = output + '-modifyBy';
    //   //   }
    //   // } //end: modal
    // })

    store.watch((state) => (state.isShowModal, state.modalType), (newType, oldType) => {
      // console.log('oldType', oldType, 'newType', newType)
      // modal type
      if (oldType === POPUP.PRIVACY) {
        console.log('contact modal change', POPUP.PRIVACY);
      } //end: modal
    })

    store.watch((state) => (state.wsOffline), () => {
      wsInit()
    })

    const queryApiWsSite = async () => {
      try {
        const datas = await apiWsSite();
        store.commit('setWsSite', datas.data);

      }
      catch (error) {
        console.log('ws error', error)
        return error;
      }
    }

    // logout
    const onLogout = async () => {
      try {
        await apiLogout();
        router.push({ name: FEATURENAME.LOGIN });
      }
      catch (err) {
        console.warn('apiLogout error', err)
      }
    } //end: logout


    const onClickLang = async (e) => {
      console.log('onClickContact', locale.value);
      console.log('onClickContact', e.val);
      console.log('onClickContact', e);
      locale.value = e.val
      localStorage.setItem('language',locale.value)
      store.commit('setLangIsSelected', locale.value)
    }
     //轉換各國語系連結
     let _urlMutiLangLink = () => {
      let _urlLang = '';
      let _url = {
        manual: `https://www.asus.com/${_urlLang}support/FAQ/1049325`,
        windows: `https://www.asus.com/${_urlLang}support/FAQ/1043733`,
      };
      let _selectedLang = locale.value;
      

      switch(_selectedLang){
        case LANG.EN:
          _urlLang = '';
          break;
        case LANG.TW:
          _urlLang = 'TW/';
          break;
        case LANG.ITA:
          _urlLang = 'it/';
          break;
        case LANG.FRE:
          _urlLang = 'fr/';
        break;
        case LANG.GER:
          _urlLang = 'de/';
          break;
        case LANG.SPAN:
          _urlLang = 'es/';
          break;
        case LANG.RUSSIAN:
          _urlLang = 'ru/';
          break;
        case LANG.TUR:
          _urlLang = 'tr/';
          break;
        case LANG.POLISH:
          _urlLang = 'pl/';
          break;
        case LANG.DUTCH:
          _urlLang = 'nl/';
          break;
        case LANG.UKR:
          _urlLang = 'ua-ua/';
          break;
        case LANG.JP: 
          _urlLang = 'jp/';
          break;
        case LANG.KOR: 
          _urlLang = 'kr/';
          break;
        case LANG.THAI:
          _urlLang = 'th/';
          break;
        case LANG.VIE:
          _urlLang = 'vn/';
          break;
        case LANG.IND:
          _urlLang = 'id/';
          break;
        default: 
          _urlLang = '';
          break;
      }

      _url = {
        manual: `https://www.asus.com/${_urlLang}support/FAQ/1049325`,
        windows: `https://www.asus.com/${_urlLang}support/FAQ/1043733`,
      };

      return _url;
    }


    const onClickInfoList = (index) => {
      let popupName = '';
      let link = _urlMutiLangLink();

      if (_env !== ENV.PROD && _env !== ENV.STAGING && _env !== ENV.DEV) {
        switch (index) {
          case 0:
            window.open(link.manual);
            break;
          case 1:
            window.open(link.windows);
            break;
          case 2:
            popupName = POPUP.AGREEMENT + '_header_' + uuid.v4();
            break;
          case 3:
            popupName = POPUP.PRIVACY + '_header_' + uuid.v4();
            break;
          case 4:
            popupName = POPUP.LICENSE + '_header_' + uuid.v4();
            break;
        }

      }else{
        switch (index) {
          
          case 0:
            window.open(link.manual);
            break;
          case 1:
            window.open(link.windows);
            break;
          case 2:
            popupName = POPUP.AGREEMENT + '_header_' + uuid.v4();
            break;
          case 3:
            popupName = POPUP.PRIVACY + '_header_' + uuid.v4();
            break;
        }

      }
      

      if (popupName !== '') {
        showPopup(popupName);
      }
      else {
        console.log('url');
      }
      
    }

    






    return {
      state,
      currentPageName,
      breadcrumb,
      sideMenuActive,
      onClickContact,
      onClickAddDevice,
      onClickLicense,
      user,
      onLogout,
      queryApiWsSite,
      refreshTime,
      t,
      sidemenu,
      onClickNotification,
      _init,
      getAPINotificationsNew,
      loginGTM,
      sideInfo,
      locale,
      onClickLang,
      onClickInfoList
    }

  }
}




